import actionTypes from 'SRC/modules/redux/actionTypes'

export const setSimilarProducts = similarProducts => ({
  type: actionTypes.SET_VEHICLE_PARTS_SIMILAR_PRODUCTS,
  payload: similarProducts
})
